import React from 'react'
import { connect } from 'react-redux'
import Router from 'next/router'
import withRouterParams from '../components/common/RouterUtils'
import { Col, message, Layout, Row } from 'antd'
import { withTranslation } from 'react-i18next'
import CatalogRoot from '../components/catalog/catalog-root'
import CatalogItems from '../components/catalog/catalog-items'
import CatalogProductDetail from '../components/catalog/catalog-product-detail'
import { uploadOrders } from '../electron/tools'
import { setShowSidePanel, setUserConfig, clearSearchProduct } from '../actions'
import SiderComponent from '../components/layout/sider'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import SearchBox from '../components/common/SearchBox'

const { Content } = Layout

class Catalog extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDetailProduct: false,
      codigodearticulo: null,
    }

    Router.events.on('routeChangeComplete', () => {
      this.onRouteChanged()
    })

    const params = this.getParams()
    if (params && params.product) {
      // this.state = { showDetailProduct: true, codigodearticulo: params.product };
    }
  }

  componentDidMount() {
    uploadOrders()
  }

  componentWillUnmount() {
    this.props.clearSearchProduct()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { successAddingProductToFavorites, successRemovingProductToFavorites, t } = this.props

    if (
      successRemovingProductToFavorites &&
      successRemovingProductToFavorites !== prevProps.successRemovingProductToFavorites
    ) {
      message.success(t('FAVORITE.DELETE_SUCCESS_MESSAGE'))
    }

    if (
      successAddingProductToFavorites &&
      successAddingProductToFavorites !== prevProps.successAddingProductToFavorites
    ) {
      message.success(t('FAVORITE.ADD_SUCCESS_MESSAGE'))
    }
  }

  onRouteChanged() {
    const params = this.getParams()
    if (params && params.product) {
      this.setState({ showDetailProduct: true, codigodearticulo: params.product })
    } else {
      this.setState({ showDetailProduct: false, codigodearticulo: null })
    }
  }

  handleModalClose = () => {
    this.props.hideItemDetail()
  }

  getBreadcrumb = () => {
    const { t } = this.props
    return [{ label: t('Catalog'), path: '/catalog' }]
  }

  handleCollapse = (value) => {
    this.props.setShowSidePanel(value)
  }

  render() {
    const { isMobile, showSidePanel } = this.props
    const { showDetailProduct, codigodearticulo } = this.state

    return (
      <CatalogRoot showBanner {...this.props} hideBCTitle>
        <Layout>
          <SiderComponent
            collapsed={!showSidePanel}
            handleCollapse={this.handleCollapse}
            isMobile={isMobile}
          />
          <Layout>
            {/* Shows the searchbox above the header on mobiles */}
            {isMobile && (
              <Row className='mobile-search-bar' align={'middle'}>
                <Col className='mobile-search-bar-button' span={1}>
                  {this.props.showSidePanel ? (
                    <MenuFoldOutlined onClick={() => this.handleCollapse(false)} />
                  ) : (
                    <MenuUnfoldOutlined onClick={() => this.handleCollapse(true)} />
                  )}
                </Col>
                <Col className='mobile-header-searchbox-input' span={19}>
                  <SearchBox catalogFilter submitOnKeys={[13]}></SearchBox>
                </Col>
              </Row>
            )}
            <Content>
              <Col>
                <div className='catalog-main-panel'>
                  <Col className='w-100'>
                    {showDetailProduct ? (
                      <CatalogProductDetail idProduct={codigodearticulo} />
                    ) : (
                      <CatalogItems isMobile={isMobile} />
                    )}
                  </Col>
                </div>
              </Col>
            </Content>
          </Layout>
        </Layout>
      </CatalogRoot>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  setShowSidePanel: (payload) => {
    dispatch(setShowSidePanel(payload))
  },
  setUserConfig: (params) => {
    dispatch(setUserConfig(params))
  },
  clearSearchProduct: () => {
    dispatch(clearSearchProduct())
  },
})

const mapStateToProps = ({ userConfig, catalog }) => {
  const { successAddingProductToFavorites, successRemovingProductToFavorites } = userConfig
  const { showSidePanel } = catalog

  return {
    successAddingProductToFavorites,
    successRemovingProductToFavorites,
    showSidePanel,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(withRouterParams(Catalog, { product: 'product' })))
